import {Component, ElementRef, Inject, OnInit, PLATFORM_ID, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AuthenticationHelperService} from 'src/app/services/helpers/authentication-helper.service';
import {PAGES_AND_PATHS} from '../../../constants/pages-and-paths';
import {EmailRegex} from '../../../constants/general-variables';
import {ActivatedRoute} from '@angular/router';
import {AuthenticationHttpService} from '../../../services/http-services/authentication/authentication-http.service';
import {LoginApiData} from '../../../services/http-services/authentication/autentication-http-interfaces';
import {ToastrService} from 'ngx-toastr';
import { isPlatformBrowser } from '@angular/common';
import {Meta, Title} from '@angular/platform-browser';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {
  isPasswordVisible = false;
  formTriedToSubmit = false;
  loginForm!: FormGroup;
  isSpinnerActive = false;
  createdNow = false;
  @ViewChild('googleBtn') googleBtn: ElementRef | undefined;
  protected readonly PAGES_AND_PATHS = PAGES_AND_PATHS;

  constructor(private authenticationHelperService: AuthenticationHelperService,
              private authenticationHttpService: AuthenticationHttpService,
              private activatedRoute: ActivatedRoute,
              private toastService: ToastrService,
              private authHelperService: AuthenticationHelperService,
              private formBuilder: FormBuilder,
              private title: Title,
              private meta: Meta,
              @Inject(PLATFORM_ID) private platformId: string) {
  }

  ngOnInit(): void {
    this.title.setTitle('TheLysts, List it, Live it! - Sign in now!');
    this.meta.updateTag({name: 'description', content: 'Do you know those lists you have lying around, and you dont even know where they are when you need them the most? With the books you want to buy, series you want to watch, the recipes you never managed to make… Bring them to TheLysts, sign in now!'});
    this.meta.updateTag({name: 'keywords', content: 'thelysts,lyst,list,task,organizer,connect,trip,suggestion,music,food,restaurants,sports,movies,films,tv series,podcasts,life style,cars,boats,app,recommendation,planner,beauty,fashion,celebrities,influencers,museums,golf,ongs'});
    this.meta.updateTag({property: 'og:title', content: 'TheLysts, List it, Live it! - Sign in now!'});
    this.meta.updateTag({property: 'og:image', content: 'https://thelysts.com/og-image/og-image-sign-in.jpg'});
    this.meta.updateTag({property: 'og:description', content: 'Do you know those lists you have lying around, and you dont even know where they are when you need them the most? With the books you want to buy, series you want to watch, the recipes you never managed to make… Bring them to TheLysts, sign in now!'});

    this.activatedRoute.queryParams.subscribe(params => {
      this.createdNow = params.now;
    });
    this.activatedRoute.params.subscribe(res => {
      if (res.token) {
        const token = decodeURIComponent(res.token);

        this.authenticationHttpService
          .loginWithApple({token})
          .then((res) => {
            if (res.data.user.hasOwnProperty('created_now')) {
              this.authHelperService.clientLogin(
                res.data.user,
                res.data.access_token,
                PAGES_AND_PATHS.appleSignUp.pagePath
              );
            } else {
              this.authHelperService.clientLogin(
                res.data.user,
                res.data.access_token,
                PAGES_AND_PATHS.home.pagePath
              );
            }
          })
          .catch((error) => {
            console.error('Error in loginWithGoogle', error);
          });
      }
    });

    this.buildForm();
    this.loginForm.controls.email.valueChanges.subscribe(value => {
      const trimmedValue = value.trim();
      if (value !== trimmedValue) {
        this.loginForm.controls.email.setValue(trimmedValue, { emitEvent: false });
      }
    });
  }

  buildForm(): void {
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.pattern(EmailRegex)]],
      password: ['', [Validators.required, Validators.minLength(8)]],
    });
  }

  signInWithGoogle(): void {
    if (isPlatformBrowser(this.platformId)) {
      // @ts-ignore
      google.accounts.oauth2.initTokenClient({
        client_id: '485714059683-k1mgo6t1dup3ioko2o44q0acq93hr94p.apps.googleusercontent.com',
        scope: 'profile email',
        callback: (response: any) => this.handleCredentialResponse(response)
      }).requestAccessToken();
    }
  }

  handleCredentialResponse(response: any): void {
    this.authenticationHttpService.loginWithGoogle({token: response.access_token}).then((res) => {
        if (res.data.user.hasOwnProperty('created_now')) {
          this.authHelperService.clientLogin(
            res.data.user,
            res.data.access_token,
            PAGES_AND_PATHS.googleSignUp.pagePath
          );
        } else {
          this.authHelperService.clientLogin(
            res.data.user,
            res.data.access_token,
            PAGES_AND_PATHS.home.pagePath
          );
        }
      });
  }

  async signInWithApple(): Promise<void> {
    if (isPlatformBrowser(this.platformId)) {
      this.authenticationHttpService.loginWithAppleGetRedirect().then(async r => {
        window.open(r.body.data, '_self');
      });
    }
  }

  onSubmitLoginForm(): void {
    this.formTriedToSubmit = true;
    if (this.loginForm.valid) {
      this.isSpinnerActive = true;
      this.authenticationHttpService.login(this.loginForm.value).then((res: LoginApiData) => {
        this.isSpinnerActive = false;
        this.authenticationHelperService.clientLogin(res.data.user, res.data.access_token, PAGES_AND_PATHS.home.pagePath);
      }).catch(error => {
        this.isSpinnerActive = false;
        if (error.error.code === 403) {
          this.toastService.error();
        } else {
          Object.values(error.error.data).forEach((value: any) => this.toastService.error(value));
        }
      });
    }
  }
}
